import React, { useEffect, useState } from "react";
import dataService from "../networks/api/service/dataService";
import { Select } from "antd";
import GreivanceTable from "../components/GreivanceTable";
import zIndex from "@mui/material/styles/zIndex";
const { Option } = Select;

function ConstituencyGreivanceList() {
  const [constituencyList, setconstituencyList] = useState([]);
  const [grievances, setGrievances] = useState([]);
  const [loading, setLoading] = useState(false);

  const [constituencyId, setconstituencyId] = useState("");

  const getConstituency = async () => {
    try {
      const res = await dataService.getAllConstituency();
      if (res.code === 200) setconstituencyList(res.data);
    } catch (e) {
      console.error(e);
    }
  };

  // const getGrievanceList = async (value) => {
  //   try {
  //     const res = await dataService.getConstituencyGreivance(value);
  //     if (res.code === 200) {
  //       setGrievances(res.data);
  //     }
  //   } catch (e) {
  //     console.error(e);
  //   }
  // };

  const fetchGrievances = async () => {
    setLoading(true);
    try {
      const res = await dataService.getConstituencyGreivance();
      console.log("API Response:", res.data);

      const formattedData = res.data.map((item) => ({
        _id: item._id,
        email: item.email,
        nameOfApplicant: item.nameOfApplicant,
        mobileNo: item.mobileNo,
        problemRelatedToSection: item.problemRelatedToSection,
        levelOfIssue: item.levelOfIssue,
        status: item.status,
        descriptionOfProbles: item.descriptionOfProbles,
        authorityToBeSattled: item.authorityToBeSattled,
        contactPersonMobileNo: item.contactPersonMobileNo,

        constituencyName: item.constituencyName,
        adminName: item.adminName,
        adminId: item.adminId,
        statusHistory: item.statusHistory,

        // isAdminAssigned: item.isAdminAssigned ? "Assigned" : "Not Assigned",
      }));

      setGrievances(formattedData);
    } catch (error) {
      console.error("Error fetching grievances:", error);
      setGrievances([]);
    } finally {
      setLoading(false);
    }
  };

  const OnConstituencySelect = async (value) => {
    setconstituencyId(value);
    setLoading(true);
    try {
      const res = await dataService.getConstituencyGreivance(value);
      if (res.code === 200) {
        setGrievances(res.data);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   getConstituency();
  // }, []);

  // const getNewGrievanceList = () => {
  //   getGrievanceList(constituencyId);
  // };

  useEffect(() => {
    // const fetchData = async () => {
    //   await fetchGrievances();
    // };
    // fetchData();
    fetchGrievances();
  }, []);

  return (
    <div
      style={{
        maxHeight: "100vh",
        overflowX: "hidden",
        zIndex: "-100",
      }}
    >
      {/* <Select
        showSearch
        optionFilterProp="children"
        filterOption={(input, option) => {
          const children = option?.children;
          return String(children).toLowerCase().includes(input.toLowerCase());
        }}
        placeholder="Select Constituency"
        style={{
          width: 200,
          marginRight: 20,
          border: "1px solid grey",
          borderRadius: 5,
        }}
        onChange={OnConstituencySelect}
      >
        {constituencyList.map((item) => (
          <Option key={item._id} value={item._id}>
            {item.constituencyName}
          </Option>
        ))}
      </Select> */}
      <div>
        <GreivanceTable
          style={{}}
          grievances={grievances}
          // getNewGrievanceList={getNewGrievanceList}
          loading={loading}
          hideAssignedColumn={true}
        />
      </div>
    </div>
  );
}

export default ConstituencyGreivanceList;
